
import _ from "lodash";
import Bowser, { BROWSER_MAP, OS_MAP } from "bowser";
import { Component, Prop, Vue } from "vue-property-decorator";

import ImageComponent from "./gallery-image.vue";
import VideoComponent from "./gallery-video.vue";

import type {MediaType} from '../../types/MediaTypes';


@Component({
    components: {
        "gallery-image": ImageComponent,
        "gallery-video": VideoComponent
    } 
})
export default class GalleryComponent extends Vue {
    @Prop() readonly medias!: MediaType[]

    data: {
        showCount: number,
        dontShowSafariDownloadInstructions: boolean,
        userAgent: Bowser.Parser.ParsedResult
    } = {
        showCount: 6,
        dontShowSafariDownloadInstructions: false,
        userAgent: Bowser.parse(window.navigator.userAgent)
    }

    get showCount(): number {
        return this.data.showCount;
    }

    get galleryHasVideo(): boolean {
        return _.filter(this.medias, {mediatype: 1} ).length > 0;
    }

    get isSafariMobile(): boolean {
        return this.data.userAgent.os.name === OS_MAP.iOS && this.data.userAgent.browser.name === BROWSER_MAP.safari;
    }
   
    get showSafariDownloadInstructions(): boolean {
        return !this.data.dontShowSafariDownloadInstructions && this.galleryHasVideo && this.isSafariMobile;
    }

    showMoreClick(): void {
        this.data.showCount += 6;
    }

    dontShowAgainClick(): void {

        this.data.dontShowSafariDownloadInstructions = true;

        // Store value in local storage
        if (typeof Storage !== "undefined") {            
            localStorage.setItem("ParadymInstagramShareMobilePagePreferences", JSON.stringify({dontShowSafariDownloadInstructions: true}))
        }
    }

    mounted(): void {
        if (typeof Storage !== "undefined") {
            let preferences = localStorage.getItem("ParadymInstagramShareMobilePagePreferences");
            if (preferences != null){
                this.data.dontShowSafariDownloadInstructions = JSON.parse(preferences).dontShowSafariDownloadInstructions;
            }            
        }

        // FOR DEBUGGING
        // console.log(Bowser.parse(window.navigator.userAgent));
        // console.log("Show Safari instructions: " + this.showSafariDownloadInstructions);
        // console.log("Is Safari Mobile: " + this.isSafariMobile);
        // console.log("Gallery Has Video: " + this.galleryHasVideo);
        // console.log("User Preference: Show Safari Instructions: " + !this.data.dontShowSafariDownloadInstructions);
    }
}
